import React from 'react';
import SignupForm from '../components/Form/user/SignupForm';

function SignupPage() {
  return <SignupForm />;
}

export default SignupPage;
